<div class="page-container contact-page" *transloco="let t; read: 'contact'">
  <h1 class="title --page">{{ t('leaveUsAWord')}}</h1>

  <p class="italic mt-3 mb-4 faq-redirection">
    {{ t('haveYouCHeckYourQuestionWereNotIn')}}
    <a [routerLink]="ROUTES.FAQ.BASE" class="link --primary">{{ t('ourFAQ') }}</a>
    ?
  </p>

  <app-contact-form/>
</div>